import { render } from "./EditItemConfiguration.vue?vue&type=template&id=8ef6e1f6"
import script from "./EditItemConfiguration.vue?vue&type=script&lang=js"
export * from "./EditItemConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__